module.exports = __webpack_public_path__ + "media/images/pic/anime/badminton-front-8ae2a3cbd853c0f2c85a2451114fa628.svg";